import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './switch_password.module.scss';

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  showPassword: boolean;
};

export const SwitchPassword: FC<Props> = ({ onClick, showPassword }) => (
  <div className={styles.container} style={{ lineHeight: '1em' }}>
    <button
      type="button"
      className={styles.button}
      onClick={onClick}
      data-test-id="reveal-password"
    >
      {showPassword && (
        <span>
          <FormattedMessage id="SwitchPassword.tsx/1" />
        </span>
      )}
      {!showPassword && (
        <span>
          <FormattedMessage id="SwitchPassword.tsx/2" />
        </span>
      )}
    </button>
  </div>
);
